import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';

import { formatDate } from '@/lib/format';

const styles = StyleSheet.create({
  page: {
    padding: 60,
    fontFamily: 'Helvetica',
    backgroundColor: '#ffffff',
  },
  border: {
    borderWidth: 3,
    borderColor: '#213570',
    borderStyle: 'solid',
    padding: 40,
    textAlign: 'center',
  },
  title: {
    fontSize: 28,
    fontFamily: 'Helvetica-Bold',
    color: '#213570',
    marginBottom: 8,
  },
  subtitle: {
    fontSize: 14,
    color: '#6b7280',
    marginBottom: 30,
  },
  label: {
    fontSize: 11,
    color: '#6b7280',
    marginBottom: 4,
  },
  name: {
    fontSize: 24,
    fontFamily: 'Helvetica-Bold',
    marginVertical: 8,
  },
  description: {
    fontSize: 11,
    color: '#6b7280',
    marginBottom: 30,
  },
  detailRow: {
    fontSize: 11,
    color: '#6b7280',
    marginBottom: 4,
  },
  footer: {
    borderTopWidth: 1,
    borderTopColor: '#e5e7eb',
    borderTopStyle: 'solid',
    paddingTop: 12,
    marginTop: 30,
  },
  footerText: {
    fontSize: 9,
    color: '#9ca3af',
    marginBottom: 2,
  },
  brand: {
    fontSize: 10,
    fontFamily: 'Helvetica-Bold',
    color: '#213570',
    marginTop: 4,
  },
});

interface CertificatePdfProps {
  managerName: string;
  organizationName: string;
  completionDate: string;
  certificateId: string;
}

export function CertificatePdf({
  managerName,
  organizationName,
  completionDate,
  certificateId,
}: CertificatePdfProps) {
  return (
    <Document>
      <Page size="A4" orientation="landscape" style={styles.page}>
        <View style={styles.border}>
          <Text style={styles.title}>Certificate of Completion</Text>
          <Text style={styles.subtitle}>Menopause Awareness in the Workplace</Text>
          <Text style={styles.label}>This certifies that</Text>
          <Text style={styles.name}>{managerName}</Text>
          <Text style={styles.description}>
            has successfully completed the Metaonia Manager Training Program{'\n'}
            comprising 6 scenario-based modules on supporting employees experiencing menopause
          </Text>
          <Text style={styles.detailRow}>{formatDate(completionDate)}</Text>
          <Text style={styles.detailRow}>{organizationName}</Text>
          <View style={styles.footer}>
            <Text style={styles.footerText}>Certificate ID: {certificateId}</Text>
            <Text style={styles.brand}>Metaonia</Text>
          </View>
        </View>
      </Page>
    </Document>
  );
}
